<template>
  <UModal
    v-model:open="open"
    :close="false"
    :dismissible="false"
    title="บทช่วยสอน"
    description="คู่มือสำหรับสร้างโครงสร้าง และจัดการพนักงาน"
  >
    <template #body>
      <div class="space-y-4">
        <p class="text-zinc-800 text-base leading-6">
          บทช่วยสอนสำหรับการสร้างโครงสร้างภายในทีม เพื่อจัดระดับการบังคับบัญชา
          และการเข้าถึงข้อมูลและรายงานของพนักงาน
        </p>
        <p class="text-zinc-800 text-base leading-6">
          คุณสามารถตั้งค่าภายหลังได้
        </p>
      </div>
    </template>
    <template #footer>
      <div class="flex justify-end items-center w-full">
        <div class="flex items-center gap-3">
          <UButton
            color="primary"
            variant="outline"
            label="ตั้งค่าภายหลัง"
            @click="emit('close', false)"
          />
          <UButton
            color="primary"
            label="บทช่วยสอน"
            @click="emit('close', true)"
          />
        </div>
      </div>
    </template>
  </UModal>
</template>

<script lang="ts" setup>
const open = ref(true);

const emit = defineEmits<{
  close: [confirmed: boolean];
}>();
</script>
